import React, { Component } from 'react';
import { Card, Row, Col, FormControl, FormGroup, FormLabel, ButtonGroup, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Accordion as PrimeAccordion, AccordionTab } from 'primereact/accordion';
import _ from 'lodash';
import ptBR from 'date-fns/locale/pt-BR';
import DatePicker, { registerLocale}  from 'react-datepicker';
import Spinner from '@atlaskit/spinner';
import Switch from "react-switch";
import NumberFormat from 'react-number-format';

import { getMessageFromRequest } from '../../utils/errors';
import Popout from '../../components/Popout';
import Search from '../../components/Search';
import LoadingButton from '../../components/LoadingButton';
import { withUser } from '../../modules/User';
import api from '../../api';

import SemaforoFormatter from './SemaforoFormatter.js';
import CustomerModal from './CustomerModal';
import './styles.scss'

/*
  <SalesFrequency
    frequenciaVendas={salesFrequency}
    tabAtual={tabAtual}
  />
*/

registerLocale('ptBR', ptBR);

const defaultButtonStyle = {
  width: '100%'
}

const cityToOptions = ({ code, name, stateCode }) => ({
  label: `${code} - ${name} - ${stateCode}`,
  value: code,
});

const customerToOptions = ({ register, name }) => ({
  label: `${register} - ${name}`,
  value: register,
});

const articleToOptions = ({ code, description }) => ({
  label: `${code} - ${description}`,
  value: code,
});

const getValueFromOption = ({ value }) => value;

const getFirstDay = (date) => {
  var newDate = new Date(date)
  var firstDay = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
  return firstDay;
}

const getLastDay = (date) => {
  var newDate = new Date(date)
  var lastDay = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 0);
  return lastDay;
}

const dateFixed = (date) => new Date(date).toISOString().split('T')[0];

const INITIAL_STATE = {
  // salesFrequency
  salesFrequency: [],
  activeCustomer: undefined,

  // Paginate customers
  customersPage: 0,
  customersPages: 0,
  customersPerPageLimit: 50,
  customersPaginated: [],

  // Paginate collections
  collectionsPage: 0,
  collectionsPages: 0,
  collectionsPerPageLimit: 6,
  collectionsPaginated: [],

  // artigo de cotas
  articlesOptions: [],
  articlesSelected: [],

  // Filters
  // representante: '', // removido para não limpar representante ao rodar handleCLear
  searchedRepresentante: '',
  searchedCidade: [],
  searchedCliente: [],
  // searchedSupervisor: [],
  // suggestionPriority: '',
  route: '',
  bought: false,
  requestDate: getFirstDay(Date.now()),
  requestDateFinal: getLastDay(Date.now()),

  // Page State
  isLoading: false,
  isSending: false,
  currentIndex: 0,
  activeIndex: 0,

  // CustomerModal
  showCustomerModal: false,
  modalCustomer: '',

  // financial situations
  financialFlagsOptions: [
    {
        "label": "Limite Projetado (Verde)",
        "value": 0
    },
    {
        "label": "Limite Insuficiente (Amarelo)",
        "value": 1
    },
    {
        "label": "Sem Limite (Laranja)",
        "value": 2
    },
    {
        "label": "Limite Suspenso (Roxo)",
        "value": 3
    },
    {
        "label": "Duplicata em atraso (Vermelho)",
        "value": 4
    }
  ],
  financialFlagsSelected: [],

}

class SalesFrequency extends Component {


  state = {
    ...INITIAL_STATE,
    representante: this.props.userProps ? this.props.userProps.representativeId : '',
  }

  // Lifecycle
  componentDidMount() {
    this.handleGetQuotaArticles()
  }

  // Lifecycle
  componentDidUpdate() {

    // Quando já está logado, ao entrar na pg a request de usuário ainda não vai ter retornado o ID do representante
    // Então, é necessário rodar um spinner (está lá no render) até que tenha um objeto de user
    // Quando entrar o objeto de user, o componentDidUpdate dispara e verifica se chego
    // Caso sim, verifica se existe repId ou se é igual a 0 E, se o representante no estado está vazio e é diferente de 0 (isso é importante para evitar loop de renderização)
    // E então, seta o representante no estado
    if (this.props.userProps) {
      const { representativeId } = this.props.userProps;
      if ((representativeId || representativeId === 0) && (!this.state.representante && this.state.representante !== 0)) {
        this.setState({ representante: representativeId });
      }
    }
  }

  // Handlers

  handleActiveIndex = activeIndex => this.setState({ activeIndex });

  /*
  * Uma função para mudança de estado para todos
  * os campos "Input" da tela, para melhorar a
  * visualização do código.
  */
  handleFieldChange = e => this.setState({ [e.target.name]: e.target.value });

  /*
  * Uma função para mudança de estado para todos
  * os campos "Date" da tela, para melhorar a
  * visualização do código.
  */
  handleDateChange = (name, value) => this.setState({ [name]: value });

  handleRequestDate = requestDate => this.setState({ requestDate: getFirstDay(requestDate) });

  handleRequestDateFinal = requestDateFinal => this.setState({ requestDateFinal: getLastDay(requestDateFinal) });

  handleSearchedCidade = searchedCidade => this.setState({ searchedCidade });

  handleSearchedCliente = searchedCliente => this.setState({ searchedCliente });

  handleSearchedSupervisor = searchedSupervisor => this.setState({ searchedSupervisor });

  handleArticle = articlesSelected => this.setState({ articlesSelected });

  handleFinancialFlags = financialFlagsSelected => this.setState({ financialFlagsSelected });

  handleClear = () => this.setState({ 
    ...INITIAL_STATE, 
    tabAtual: this.state.tabAtual, 
    articlesOptions: this.state.articlesOptions, 
    articlesSelected: this.state.articlesOptions,
    financialFlagsOptions: this.state.financialFlagsOptions,
    financialFlagsSelected: this.state.financialFlagsOptions
  });

  // Modal
  handleOpenCustomerModal = (customer) => this.setState({ showCustomerModal: true, modalCustomer: customer });
  handlecloseCustomerModal = () => this.setState({ showCustomerModal: false, modalCustomer: '' });

  // Request

  handleSalesFrequency = async () => {
    const {
      requestDate,
      requestDateFinal,
      articlesSelected,
      representante,
      // prioridadeSugestao,
      route,
      bought,
      searchedCidade,
      searchedCliente,
      searchedRepresentante,
      financialFlagsSelected,
    } = this.state;

    const rep = representante === 0 ? searchedRepresentante : representante;

    const params = {
      initialIssueDate: dateFixed(requestDate),
      finalIssueDate: dateFixed(requestDateFinal),
      bought: bought,      
      representativeId: rep,
      // prioridadeSugestao: prioridadeSugestao,      
      cities: searchedCidade.map(getValueFromOption).toString(),
      customers: searchedCliente.map(getValueFromOption).toString(),
      route: route,
      quotaArticles: articlesSelected.map(getValueFromOption).toString(),
      financialFlags: financialFlagsSelected.map(getValueFromOption).toString(),
    };
    this.setState({ 
      isLoading: true, 
      salesFrequency: [], 
      activeCustomer: undefined,
      customersPage: 0,
      customersPages: 0,
      customersPerPageLimit: 50,
      customersPaginated: [],
    });
    try {
      const { data: salesFrequency } = await api.comercial.customer.getSaleFrequency(
        { params: params }
      );

      this.customersPaginate(salesFrequency);
    } catch (err) {
      toast.error(`Erro ao consultar Frequência de Vendas: ${err.message}`);
    } finally {
      this.setState({ isLoading: false, activeIndex: null });
    }
  }

  // Quota Articles
  handleGetQuotaArticles = async () => {
    this.setState({ isLoading: true, articlesSelected: [], articlesOptions: [] });
    try {
      const { data } = await api.comercial.filters.quotaArticle.getAll()

      if(data.length === 0) {
        toast.warn('Nenhum artigo encontrado!')
        return;
      }

      const articlesOptions = data.map((article) => articleToOptions(article))
      this.setState({ articlesOptions, articlesSelected: articlesOptions })
    } catch (err) {
      toast.error(`Erro ao consultar Artigos de Cotas: ${err.message}`);
    } finally {
      this.setState({ isLoading: false });
    }
  }
  
  // Paginate Customer
  customerNextPage = () => {
    const { customersPage } = this.state;
    this.setState({ customersPage: customersPage + 1 })
  }

  customerPreviousPage = () => {
    const { customersPage } = this.state;
    this.setState({ customersPage: customersPage - 1 })
  }

  customersPaginate = (salesFrequency) => {
    let customersPaginated = [];
    let customers = [];

    if(salesFrequency.length === 0) return [];

    const { customersPerPageLimit } = this.state;

    for(let customer of salesFrequency) {
      if(customers.length === customersPerPageLimit) {
        customersPaginated[customersPaginated.length] = customers;
        customers = [];
      }

      customers.push(customer)
    }

    // repete o processo com os que sobraram
    customersPaginated[customersPaginated.length] = customers;

    this.setState({ 
      salesFrequency: salesFrequency, 
      customersPaginated,
      customersPage: 1,
      customersPages: customersPaginated.length
    })
  }

  // Paginate Collections
  collectionNextPage = () => {
    const { collectionsPage } = this.state;
    this.setState({ collectionsPage: collectionsPage + 1 })
  }

  collectionPreviousPage = () => {
    const { collectionsPage } = this.state;
    this.setState({ collectionsPage: collectionsPage - 1 })
  }

  collectionsPaginate = (activeCustomer) => {
    const customerCollections = activeCustomer.collections;

    let collectionsPaginated = [];
    let collections = [];

    if(customerCollections.length === 0) return [];

    const { collectionsPerPageLimit } = this.state;

    for(let collection of customerCollections) {
      if(collections.length === collectionsPerPageLimit) {
        collectionsPaginated[collectionsPaginated.length] = collections;
        collections = [];
      }

      collections.push(collection)
    }

    // repete o processo com os que sobraram
    collectionsPaginated[collectionsPaginated.length] = collections;

    this.setState({ 
      activeCustomer: activeCustomer,
      collectionsPaginated,
      collectionsPage: 1,
      collectionsPages: collectionsPaginated.length
     })
  }

  // Render Customer Cards
  renderCustomers = (customersPaginated, salesFrequency) => {

    const potentialTotal = this.customersTotalPotential(salesFrequency)

    const { 
      customersPage,
      customersPages
    } = this.state;

    const customersArr = customersPaginated[customersPage - 1] ? customersPaginated[customersPage - 1] : []

    return (
      <>
        <Card className="totals-card" >
          <Card.Header className="totals-card-header" >
            <Row>
              <Col className="totals-card-header-col" >
                <FormLabel>Número de clientes</FormLabel>
                <FormControl
                  className="rounded-input"
                  type="text"
                  name="customerQuantity"
                  value={salesFrequency.length ? salesFrequency.length : 0}
                  disabled
                />
              </Col>
              <Col className="totals-card-header-col" >
                <FormLabel>Potencial total</FormLabel>
                <NumberFormat
                  className="form-control"  // className="rounded-input"
                  decimalScale={2}
                  thousandSeparator="."
                  decimalSeparator=","
                  prefix={'R$'}
                  fixedDecimalScale
                  readOnly
                  value={potentialTotal ? potentialTotal : 0}
                  name="customerPotentialTotal"
                  disabled
                />
              </Col>
              <Col md={2} lg={2} className="col-paginate" >
                <Row >
                <Col className="paginate-col-left" >
                    <Button 
                      className="paginate-col-button"
                      variant="secondary"
                      disabled={customersPage <= 1}
                      onClick={() => this.customerPreviousPage()}
                    >
                      <i className="fas fa-arrow-left"></i>
                    </Button>
                  </Col>
                  <Col className="paginate-col-middle" >
                    <FormLabel>Página</FormLabel>
                    <FormControl
                      className="rounded-input text-center paginate-col-formControl"
                      type="text"
                      name="page"
                      value={`${customersPage}/${customersPages}`}
                      disabled
                    />
                  </Col>
                  <Col className="paginate-col-right" >
                    <Button 
                      className="paginate-col-button"
                      variant="secondary"
                      disabled={customersPage === customersPages}
                      onClick={() => this.customerNextPage()}
                    >
                      <i className="fas fa-arrow-right"></i>
                    </Button>
                  </Col>      
                </Row>          
              </Col>
            </Row>
          </Card.Header>
        </Card>
        {
          (customersArr.length > 0) && (
          <Card className="data-card" >
            <Card.Body 
              className="align-items-center data-card-body"
            >
              <div >
                <Row>
                  { 
                    customersArr.map((customer, i) => {
                      return (
                        <Col 
                          key={i} xs={12} md={12}lg={6} 
                          className="map-col"
                        >
                          <Card >
                            <Card.Header className="map-card-header-customer" >
                              <span><SemaforoFormatter value={customer.financialFlag} size={8} /></span>
                              {customer.name}
                              <Button 
                                className="header-customer-button"
                                variant="secondary"
                                onClick={() => this.handleOpenCustomerModal(customer)}
                                style={{ right: "40px" }}
                              >
                                <i className='fas fa-user-cog'/>
                              </Button>
                              <Button 
                                className="header-customer-button"
                                variant="secondary"
                                onClick={() => this.openCustomerColletions(customer)}
                              >
                                <i className='fa fa-external-link'/>
                              </Button>
                            </Card.Header>
                            <Card.Body className="map-card-body" >
                              <Row>
                                <Col 
                                  xs={6} md={3}lg={3}  
                                  className="card-body-col"
                                >
                                  <FormLabel>Rota</FormLabel>
                                  <FormControl
                                    className="rounded-input"
                                    type="text"
                                    name="customerRoute"
                                    value={customer.route.toString() ? customer.route : 'Sem informação'}
                                    disabled
                                  />
                                </Col>
                                <Col 
                                  xs={6} md={3}lg={3}  
                                  className="card-body-col"
                                >
                                  <FormLabel>Potencial</FormLabel>
                                  <NumberFormat
                                    className="form-control"  // className="rounded-input"
                                    decimalScale={2}
                                    thousandSeparator="."
                                    decimalSeparator=","
                                    prefix={'R$'}
                                    fixedDecimalScale
                                    readOnly
                                    value={customer.salePotential ? customer.salePotential : 0}
                                    name="customerPotential"
                                    disabled
                                  />
                                </Col>
                                <Col 
                                  xs={6} md={3}lg={3}  
                                  className="card-body-col"
                                >
                                  <FormLabel>Gp. Econômico</FormLabel>
                                  <FormControl
                                    className="rounded-input"
                                    type="text"
                                    name="customerEconomicGroup"
                                    value={customer.economicGroup ? customer.economicGroup : 'Sem informação'}
                                    disabled
                                  />
                                </Col>
                                <Col 
                                  xs={6} md={3}lg={3}  
                                  className="card-body-col"
                                >
                                  <FormLabel>Cidade/ UF</FormLabel>
                                  <FormControl
                                    className="rounded-input"
                                    type="text"
                                    name="customerCity"
                                    value={customer.city ? customer.city : 'Sem informação'}
                                    disabled
                                  />
                                </Col>
                              </Row>
                            </Card.Body>
                          </Card>
                        </Col>
                      )
                    })
                  }
                </Row>
              </div>
            </Card.Body>
          </Card>
          )
        }
      </>
    )
  }

  // Calculate customer total potential
  customersTotalPotential = (salesFrequency) => {
    let total = 0;
    for(let customer of salesFrequency) {
      total = total + customer.salePotential;
    }
    return total;
  }

  // Customer Collections
  openCustomerColletions = (customer) => {
    this.collectionsPaginate(customer)
  }

  closeCustomerColletions = () => {
    this.setState({ activeCustomer: undefined })
  }

  sumTotalCollections = (collections) => {
    let data = {
      parts: 0,
      references: 0,
      value: 0,
      averagePrice: 0,
    }

    let totalSold = 0;
    let qtdAvgPrice = 0;

    for(let collection of collections) {
      // Parts
      data.parts = data.parts + (collection.parts ? collection.parts : 0);

      // Refs
      data.references = data.references + (collection.references ? collection.references : 0);

      // Value
      data.value = data.value + (collection.value ? collection.value : 0);
      
      // Avg price
      totalSold = totalSold + (collection.averagePrice ? collection.averagePrice : 0);
      qtdAvgPrice = qtdAvgPrice + (collection.averagePrice ? 1 : 0);
    }

    // Avg Price
    data.averagePrice = totalSold /  (qtdAvgPrice > 0 ?  qtdAvgPrice : 1)

    return data;
  }

  renderCustomerCollections = (collectionsPaginated, activeCustomer) => {

    const totals = this.sumTotalCollections(activeCustomer.collections)

    const { 
      collectionsPage,
      collectionsPages
    } = this.state;

    const collectionsArr = collectionsPaginated[collectionsPage - 1] ? collectionsPaginated[collectionsPage - 1] : []

    return (
      <>
        <Card className="totals-card" >
          <Card.Header className="totals-card-header" >
            <Row>
              <Col className="totals-card-header-col" >
                <FormLabel>Peças</FormLabel>
                <FormControl
                  className="rounded-input"
                  type="text"
                  name="collectionParts"
                  value={totals.parts ? totals.parts : 0}
                  disabled
                />
              </Col>
              <Col className="totals-card-header-col" >
                <FormLabel>Refs</FormLabel>
                <FormControl
                  className="rounded-input"
                  type="text"
                  name="collectionRefs"
                  value={totals.references ? totals.references : 0}
                  disabled
                />
              </Col>
              <Col className="totals-card-header-col" >
                <FormLabel>Valor</FormLabel>
                <NumberFormat
                  className="form-control"  // className="rounded-input"
                  decimalScale={2}
                  thousandSeparator="."
                  decimalSeparator=","
                  prefix={'R$'}
                  fixedDecimalScale
                  readOnly
                  value={totals.value ? totals.value : 0}
                  name="collectionValue"
                  disabled
                />
              </Col>
              <Col className="totals-card-header-col" >
                <FormLabel>PM</FormLabel>
                <NumberFormat
                  className="form-control"  // className="rounded-input"
                  decimalScale={2}
                  thousandSeparator="."
                  decimalSeparator=","
                  prefix={'R$'}
                  fixedDecimalScale
                  readOnly
                  value={totals.averagePrice ? totals.averagePrice : 0}
                  name="collectionAvgPrice"
                  disabled
                />
              </Col>
              <Col md={2} lg={2} className="col-paginate" >
                <Row >
                  <Col className="paginate-col-left" >
                    <Button 
                      className="paginate-col-button"
                      variant="secondary"
                      disabled={collectionsPage <= 1}
                      onClick={() => this.collectionPreviousPage()}
                    >
                      <i className="fas fa-arrow-left"></i>
                    </Button>
                  </Col>
                  <Col className="paginate-col-middle" >
                    <FormLabel>Página</FormLabel>
                    <FormControl
                      className="rounded-input text-center paginate-col-formControl"
                      type="text"
                      name="page"
                      value={`${collectionsPage}/${collectionsPages}`}
                      disabled
                    />
                  </Col>
                  <Col className="paginate-col-right" >
                    <Button 
                      className="paginate-col-button"
                      variant="secondary"
                      disabled={collectionsPage === collectionsPages}
                      onClick={() => this.collectionNextPage()}
                    >
                      <i className="fas fa-arrow-right"></i>
                    </Button>
                  </Col>      
                </Row>          
              </Col>
            </Row>
          </Card.Header>
        </Card>
        <Card className="data-card" >
          <Card.Header className="data-card-header" >
            <span ><SemaforoFormatter value={activeCustomer.financialFlag} size={8} /></span>
            {activeCustomer.name}
            <Button 
              variant="secondary"
              className="header-button "
              onClick={() => this.closeCustomerColletions()}
            >
              <i className="fas fa-undo"></i>
            </Button>
          </Card.Header>
          <Card.Body 
            className="align-items-center data-card-body"
          >
            <div>
              <Row>
                {
                  collectionsArr.map((collection, i) => {
                    const bgColor = collection.parts > 0 ? '#7ce393' : '#FF727F';
                    return (
                      <Col 
                        key={i} xs={12} md={12}lg={6} 
                        className="map-col"
                      >
                        <Card >
                          <Card.Header 
                            style={{ backgroundColor: bgColor }} 
                            className="map-card-header"
                          >
                            <FormLabel className="header-formLabel" >
                              {collection.collectionDescription}
                            </FormLabel>
                          </Card.Header>
                          <Card.Body className="map-card-body" >
                            <Row>
                              <Col 
                                xs={6} md={3}lg={3}  
                                className="card-body-col"
                              >
                                <FormLabel>Peças</FormLabel>
                                <FormControl
                                  className="rounded-input"
                                  type="text"
                                  name="collectionParts"
                                  value={collection.parts ? collection.parts : 0}
                                  disabled
                                />
                              </Col>
                              <Col 
                                xs={6} md={3}lg={3}  
                                className="card-body-col"
                              >
                                <FormLabel>Refs</FormLabel>
                                <FormControl
                                  className="rounded-input"
                                  type="text"
                                  name="collectionRefs"
                                  value={(collection.references && collection.references !== 0) ? collection.references : 'Sem informação'}
                                  disabled
                                />
                              </Col>
                              <Col 
                                xs={6} md={3}lg={3}  
                                className="card-body-col"
                              >
                                <FormLabel>Valor</FormLabel>
                                <NumberFormat
                                  className="form-control"  // className="rounded-input"
                                  decimalScale={2}
                                  thousandSeparator="."
                                  decimalSeparator=","
                                  prefix={'R$'}
                                  fixedDecimalScale
                                  readOnly
                                  value={collection.value ? collection.value : 0}
                                  name="collectionValue"
                                  disabled
                                />
                              </Col>
                              <Col 
                                xs={6} md={3}lg={3}  
                                className="card-body-col"
                              >
                                <FormLabel>PM</FormLabel>
                                <NumberFormat
                                  className="form-control"  // className="rounded-input"
                                  decimalScale={2}
                                  thousandSeparator="."
                                  decimalSeparator=","
                                  prefix={'R$'}
                                  fixedDecimalScale
                                  readOnly
                                  value={collection.averagePrice ? collection.averagePrice : 0}
                                  name="collectionAvgPrice"
                                  disabled
                                />
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      </Col>
                    )
                  })
                }
              </Row>
            </div>
          </Card.Body>
        </Card>
      </>
    )
  }

  // Handlers
  
  handleBoughtSwitch = () => {
    const { bought } = this.state;
    this.setState({ bought: !bought });
  }

  // Transforma o frequencia venda em keys com id (value => value123)

  getFrequenciaVendas = (frequenciaVendas) => {
    let newFrequenciaVendas = frequenciaVendas;

    newFrequenciaVendas.forEach(customer => {
      customer.collections.forEach(collection => {
        let code = collection.collection;

        Object.keys(collection).forEach(key => {
          let keyString = key.toString();
          let newKey = keyString+code;
          customer[newKey] = collection[key];
        })
        
      })
    })

    return newFrequenciaVendas;
  }

  // Loads

  loadCities = _.debounce((inputValue, callback) => {
    api.comercial.filters.city.search(inputValue).then(
      ({ data: searchOptions }) => {
        const result = searchOptions.map(cityToOptions)
        callback(result);
      }
    ).catch((err) => {
      const message = getMessageFromRequest(err)
      toast.error(message);
    })
  }, 700, { trailing: true, leading: false })

  loadCustomers = _.debounce((inputValue, callback) => {
    api.comercial.filters.customer.search(inputValue).then(
      ({ data: searchOptions }) => {
        const result = searchOptions.map(customerToOptions)
        callback(result);
      }
    ).catch((err) => {
      const message = getMessageFromRequest(err)
      toast.error(message);
    })
  }, 700, { trailing: true, leading: false }) 

  render() {
    const { 
      // Quota Articles
      articlesOptions,
      articlesSelected,

      // SalesFrequency
      salesFrequency,
      activeCustomer,

      // Paginate customers
      customersPaginated,

      // Paginate collections
      collectionsPaginated,

      // Filters
      representante,
      searchedRepresentante,
      searchedCidade,
      searchedCliente,
      // searchedSupervisor,
      // suggestionPriority,
      route,
      bought,
      requestDate,
      requestDateFinal,

      // Page State
      isLoading,
      // isSending,
      activeIndex,

      // CustomerModal
      showCustomerModal,
      modalCustomer,

      // Financial Situations
      financialFlagsOptions,
      financialFlagsSelected,
    } = this.state;

    if(representante === '') return (
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: '100%',
          alignItems: 'center',
          justifyContent: 'center'
        }} 
      >
        <Spinner 
          size='xlarge'  
        />
      </div>
    )

    return (
      <div
        className="potential-container"
      >
        {
          showCustomerModal && (
            <CustomerModal 
              modalCustomer={modalCustomer}
              show={showCustomerModal}
              onClose={() => this.handlecloseCustomerModal()}
            />
          )
        }
        <Col 
          xs={12} md={12} lg={12}
          className="max-width-col"
        >
          <div className="acompVendas-container">
            <PrimeAccordion
              activeIndex={activeIndex}
              onTabChange={e => this.handleActiveIndex(e.index)}
              style={{ marginBottom: '0.8vh' }}
            >
              <AccordionTab header="Filtros">
                <Row>
                  {(representante === 0) && (
                    <Col md={3}>
                      <FormGroup>
                        <FormLabel>Representante</FormLabel>
                        <FormControl
                          style={{ marginBottom: '20px' }}
                          className="rounded-input"
                          type="text"
                          name="searchedRepresentante"
                          value={searchedRepresentante}
                          onChange={this.handleFieldChange}
                          disabled={representante !== 0}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {(
                    <Col md={3}>
                      <FormGroup>
                        <FormLabel>Cidade</FormLabel>
                        <Popout
                          buttonStyle={defaultButtonStyle}
                          title="Selecione um(a)"
                          isMulti
                          loadOptions={this.loadCities}
                          onChange={this.handleSearchedCidade}
                          value={searchedCidade}
                          Component={Search}
                          maxDisplay={1}
                          disabled={!representante}
                          menuWidth={'100%'}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {(
                    <Col md={3}>
                      <FormGroup>
                        <FormLabel>Cliente</FormLabel>
                        <Popout
                          buttonStyle={defaultButtonStyle}
                          title="Selecione um(a)"
                          isMulti
                          loadOptions={this.loadCustomers}
                          onChange={this.handleSearchedCliente}
                          value={searchedCliente}
                          Component={Search}
                          maxDisplay={1}
                          disabled={!representante}
                          menuWidth={'100%'}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {(
                    <Col md={2}>
                      <FormGroup>
                        <FormLabel style={{ marginBottom: "11px" }}>Rota</FormLabel>
                        <FormControl 
                          className="rounded-input"
                          name="route"
                          value={route}
                          onChange={this.handleFieldChange}
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {(
                    <Col md={2}>
                      <FormGroup>
                        <FormLabel>Coleções</FormLabel>
                        <Popout                            
                          name="artigo"
                          buttonStyle={defaultButtonStyle}
                          title="Selecione um(a)"
                          isMulti
                          isSearchable
                          isClearable={true}
                          maxDisplay={1}
                          menuWidth={'100%'}
                          options={articlesOptions}
                          onChange={this.handleArticle}
                          value={articlesSelected}                            
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {(
                    <Col md={2}>
                      <FormGroup>
                        <FormLabel>Sit. Financeira</FormLabel>
                        <Popout                            
                          name="situacaoFinanceira"
                          buttonStyle={defaultButtonStyle}
                          title="Selecione um(a)"
                          isMulti
                          isSearchable
                          isClearable={true}
                          maxDisplay={1}
                          menuWidth={'100%'}
                          options={financialFlagsOptions}
                          onChange={this.handleFinancialFlags}
                          value={financialFlagsSelected}                            
                        />
                      </FormGroup>
                    </Col>
                  )}
                  {(
                    <Col md={2} >
                      <FormGroup>
                        <FormLabel>Comprou</FormLabel>
                        <div>
                          <Switch
                            checked={bought}
                            onChange={this.handleBoughtSwitch}
                            offColor="#dc3545"
                            onColor="#28a745"
                            width={120}
                            uncheckedIcon={
                              <div style={{ width: "60px", marginLeft: "-40px" }} className="switch-center switch-unchecked">
                                Sem Compra
                              </div>
                            }
                            checkedIcon={
                              <div style={{ width: "70px", marginRight: "-40px" }} className="switch-center switch-checked">
                                Com Compra
                              </div>
                            }
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  )}
                  {(
                    <Col md={3}>
                      <FormGroup>
                        <FormLabel>Emissão</FormLabel>
                        <div className="date-filter d-flex justify-content-between">
                          <DatePicker
                            className="form-control rounded-input"
                            selected={requestDate}
                            selectsStart
                            locale="ptBR"
                            startDate={requestDate}
                            onChange={this.handleRequestDate}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                          />
                          <i className="fa fa-arrow-right fa-md mt-2" />
                          <DatePicker
                            className="form-control rounded-input"
                            selected={requestDateFinal}
                            selectsStart
                            locale="ptBR"
                            startDate={requestDateFinal}
                            onChange={this.handleRequestDateFinal}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                          />
                        </div>
                      </FormGroup>
                    </Col>
                  )}
                  {/* {(tabAtual === 'clientes' || tabAtual === 'frequenciaVendas') && (
                    <Col md={1}>
                      <FormGroup>
                        <FormLabel style={{ marginBottom: "11px" }}>PS</FormLabel>
                        <FormControl 
                          className="rounded-input"
                          name="prioridadeSugestao"
                          value={prioridadeSugestao}
                          onChange={this.handleFieldChange}
                        />
                      </FormGroup>
                    </Col>
                  )} */}
                  <Col md={3}>
                    <div className="actions">
                      <FormGroup style={{ marginTop: "29px" }}>
                        <ButtonGroup>
                          {(
                            <LoadingButton
                              type="button"
                              variant="success"
                              title="Consultar"
                              onClick={this.handleSalesFrequency}
                              isLoading={isLoading}
                              // disabled={!representante && searchedCidade.length === 0 && searchedCliente.length === 0 && searchedSupervisor.length === 0}
                            >
                              {Button}
                            </LoadingButton>
                          )}
                          {(
                            <Button
                              className="btn btn-secondary"
                              onClick={this.handleClear}
                            >
                              Limpar
                            </Button>
                          )}
                        </ButtonGroup>
                      </FormGroup>
                    </div>
                  </Col>
                </Row>
              </AccordionTab>
            </PrimeAccordion>
          </div>
          {
            (!activeCustomer) &&
            this.renderCustomers(customersPaginated, salesFrequency)
          }
          {
            (activeCustomer) && 
            this.renderCustomerCollections(collectionsPaginated, activeCustomer)
          }
        </Col >
      </div>
    );
  }
}

export default withUser(SalesFrequency);
